import { injectEntityList } from '../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { IEntityListStore } from '../../../../../../common/store/interface/IEntityListStore';
import { IPrimitiveStore } from '../../../../../../common/store/interface/IPrimitiveStore';
import { IProjectLearningReportArg } from '../../../../../../service/report/interface/IProjectLearningReportArg';
import { ILearningProjectRatingModel } from '../../../../../../service/report/interface/ILearningProjectRatingModel';
import { IProjectRatingsDomain } from './IProjectRatingsDomain';
import { IProjectRatingsUI } from './IProjectRatingsUI';

export class ProjectRatingsUI implements IProjectRatingsUI {
  private alreadyBooted: IPrimitiveStore<boolean>;
  isFetching: IPrimitiveStore<boolean>;
  rows: IEntityListStore<ILearningProjectRatingModel>;

  constructor(
    private projectRatingsDomain: IProjectRatingsDomain,
    private reportArg: IProjectLearningReportArg = {},
  ) {
    this.alreadyBooted = injectPrimitive(false);
    this.isFetching = injectPrimitive(false);
    this.rows = injectEntityList<ILearningProjectRatingModel>([]);
  }

  boot = async () => {
    if (this.alreadyBooted.value) return;
    this.isFetching.setValue(true);
    try {
      this.rows.setList(await this.projectRatingsDomain.getProjectRatings(this.reportArg));
    } finally {
      this.alreadyBooted.setValue(true);
      this.isFetching.setValue(false);
    }
  };

  search = async (searchTerm: string) => {
    this.isFetching.setValue(true);
    try {
      this.rows.setList(
        await this.projectRatingsDomain.getProjectRatings({
          ...this.reportArg,
          search: searchTerm || undefined,
        }),
      );
    } finally {
      this.isFetching.setValue(false);
    }
  };
}
